package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
internal data class CreateAccount2ClientRequestInfo(
    val email: String,
    val password: String,
    val firstName: String?,
    val lastName: String?,
    val postalCode: String?,
    val phoneNumber: String?,
    val reCaptchaToken: String?,
    val messageToken: String?,
    val birthDate: String?,
    val gender: String?
)